import { GlideIcon } from "@glide/common";
import type { ModuleOption } from "./module-lab";
import { SwitchToggle } from "@glide/designer-components";

type ModuleChromeProps = {
    selectedModule: string;
    availableModules: ModuleOption[];
    setSelectedModule: (module: string) => void;
    isDevMode: boolean;
    isPreviewMode: boolean;
    setIsDevMode: (devMode: boolean) => void;
};

export const ModuleLabChrome = ({
    selectedModule = "",
    setSelectedModule,
    availableModules,
    isDevMode,
    setIsDevMode,
    isPreviewMode,
}: ModuleChromeProps) => {
    return (
        <div tw="bg-bg-middle border-b border-border-base p-4 flex items-center justify-between">
            <div tw="flex items-center space-x-2">
                <GlideIcon kind="stroke" icon="st-research-lab" iconSize={24} strokeColor="var(--gv-text-base)" />
                <h1 tw="text-xl font-semibold text-text-dark">Module Lab</h1>
            </div>
            <div tw="flex items-center space-x-4">
                {!isPreviewMode && (
                    <div tw="flex items-center space-x-2">
                        <p tw="text-builder-xs text-text-xpale">LIVE</p>
                        <SwitchToggle
                            size={"sm"}
                            toggled={isDevMode}
                            onChange={checked => {
                                setIsDevMode(checked);
                            }}
                        />
                        <p tw="text-builder-xs text-text-xpale">DEV</p>
                    </div>
                )}
                <div tw="relative">
                    <select
                        disabled={isPreviewMode}
                        tw="px-3 py-2 pr-8 border border-border-base rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent text-text-base appearance-none bg-bg-front w-full"
                        value={selectedModule}
                        onChange={e => setSelectedModule(e.target.value)}>
                        {availableModules.map(module => (
                            <option key={module.value} value={module.value}>
                                {module.label}
                            </option>
                        ))}
                    </select>
                    <div tw="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg tw="w-5 h-5 text-text-pale" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};
